var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('final-payments-list',{attrs:{"title":"Pagaments finals pendents de cobrar","items":_vm.parsedPendingFinalPayments}})}
var staticRenderFns = []

export { render, staticRenderFns }